import React, { useContext } from 'react';
import Style from './Curriculum.module.scss';
import { Box } from "@mui/material";
import { info } from "../../info/Info";
import { LanguageContext } from '../../context/LanguageContext';

function CurriculumEN() {
    return (
        <>
            {/* LEFT SIDEBAR */}
            <Box className={Style.sidebar}>
                <Box className={Style.photoContainer}>
                    <img src={info.selfPortrait} alt="Profile" />
                </Box>
                
                <h1 className={Style.name}>Helber Ferreira<br/>Spencer</h1>
                <h2 style={{textAlign: 'center', fontSize: '1.15rem', color: '#666', marginTop: '-1.5rem', marginBottom: '2.5rem', fontWeight: 500}}>Software Developer & DevOps Engineer</h2>
                
                <Box className={Style.sidebarSection}>
                    <p><strong>Nationality:</strong> Cape Verdean</p>
                    <p><strong>Residence:</strong> Portugal</p>
                </Box>

                <Box className={Style.sidebarSection}>
                    <h3>Contact</h3>
                    <p><i className="fa-solid fa-location-dot"></i> Lisbon, Portugal</p>
                    <p><i className="fa-solid fa-envelope"></i> <a href="mailto:helber@dudedev.com">helber@dudedev.com</a></p>
                    <p><i className="fa-solid fa-phone"></i> (+351) 923174990</p>
                    <p><i className="fa-brands fa-linkedin"></i> <a href="https://linkedin.com/in/SEU-LINKEDIN-AQUI" target="_blank" rel="noreferrer">linkedin.com/in/helber</a></p>
                    <p><i className="fa-brands fa-github"></i> <a href="https://github.com/SEU-GITHUB-AQUI" target="_blank" rel="noreferrer">github.com/helber</a></p>
                </Box>
            </Box>

            {/* MAIN CONTENT */}
            <Box className={Style.mainContent}>
                <h2 className={Style.sectionTitle}>About Me</h2>
                <Box className={Style.textSection}>
                    Technology professional with solid experience in web/mobile application development and infrastructure management (Linux/DevOps). I have an analytical profile, high adaptability, and the ability to quickly learn new technology stacks. With hands-on experience ranging from startup ideation and architecture to deployment and server administration, I strive to deliver robust, secure digital solutions with excellent usability. I value teamwork, clear communication, and the continuous optimization of software engineering processes.
                </Box>

                <h2 className={Style.sectionTitle}>Work Experience</h2>
                <Box className={Style.timeline}>
                    <Box className={Style.timelineItem}>
                        <div className={Style.date}>19/10/2020 – 07/04/2021 Seychelles</div>
                        <div className={Style.title}>Software Developer & CEO <span style={{fontWeight: 400}}>Linkup (Startup)</span></div>
                        <div className={Style.description}>
                            <ul>
                                <li>End-to-end development of a ride-hailing mobile application.</li>
                                <li>Strategic management and executive leadership (CEO) of the startup operating in the Seychelles.</li>
                                <li>Development of mobile and backend architecture for real-time support.</li>
                            </ul>
                        </div>
                    </Box>

                    <Box className={Style.timelineItem}>
                        <div className={Style.date}>04/06/2021 – 2022 Vitória, Brazil</div>
                        <div className={Style.title}>DevOps & Software Engineer <span style={{fontWeight: 400}}>Ulen Brasil</span></div>
                        <div className={Style.description}>
                            <ul>
                                <li>Development of core features for the Ulen super app platform.</li>
                                <li>Cloud infrastructure management (DevOps) focused on high availability and scalability.</li>
                                <li>Optimization of deployment routines (CI/CD) and server maintenance.</li>
                            </ul>
                        </div>
                    </Box>

                    <Box className={Style.timelineItem}>
                        <div className={Style.date}>20/01/2022 – 04/12/2023 Praia, Cape Verde</div>
                        <div className={Style.title}>Founder & Systems Administrator <span style={{fontWeight: 400}}>CV INOVATE</span></div>
                        <div className={Style.description}>
                            <ul>
                                <li>Founded and managed a technology services company.</li>
                                <li>Server administration and IT infrastructure maintenance.</li>
                                <li>Implementation and optimization of computer systems for clients.</li>
                            </ul>
                        </div>
                    </Box>

                    <Box className={Style.timelineItem}>
                        <div className={Style.date}>11/01/2022 – 04/06/2023 Praia, Cape Verde</div>
                        <div className={Style.title}>Pedagogical Leadership Intern <span style={{fontWeight: 400}}>Cesaltina Ramos Secondary School</span></div>
                        <div className={Style.description}>
                            <ul>
                                <li>Planned and executed teaching strategies, developing leadership and public speaking skills.</li>
                            </ul>
                        </div>
                    </Box>
                </Box>

                <h2 className={Style.sectionTitle}>Education & Training</h2>
                <Box className={Style.timeline}>
                    <Box className={Style.timelineItem}>
                        <div className={Style.date}>26/04/2024 – PRESENT Praia, Cape Verde</div>
                        <div className={Style.title}>iOS Developer & Linux Server Administrator <span style={{fontWeight: 400}}>UDEMY</span></div>
                        <div className={Style.description}>
                            <strong>Website</strong> <a href="https://www.udemy.com" target="_blank" rel="noreferrer" style={{color: '#004494'}}>https://www.udemy.com</a> | <strong>EQF Level</strong> Level 1 EQF
                        </div>
                    </Box>

                    <Box className={Style.timelineItem}>
                        <div className={Style.date}>03/10/2016 – 08/05/2022 Praia, Cape Verde</div>
                        <div className={Style.title}>Bachelor's Degree in Physical Education and Sports <span style={{fontWeight: 400}}>University of Cape Verde</span></div>
                        <div className={Style.description}>
                            <strong>Website</strong> <a href="https://www.unicv.edu.cv/pt/" target="_blank" rel="noreferrer" style={{color: '#004494'}}>https://www.unicv.edu.cv/pt/</a> | <strong>EQF Level</strong> Level 3 EQF
                        </div>
                    </Box>
                </Box>

                <h2 className={Style.sectionTitle}>Driving License</h2>
                <Box className={Style.timeline} style={{marginBottom: '1.5rem', paddingBottom: 0}}>
                    <Box className={Style.timelineItem} style={{marginBottom: 0}}>
                        <div className={Style.title}>Driving License: <span style={{fontWeight: 400}}>Category B</span></div>
                    </Box>
                </Box>

                <h2 className={Style.sectionTitle}>Languages</h2>
                <Box className={Style.textSection}>
                    <p style={{marginBottom: '1rem'}}><strong>MOTHER TONGUE(S):</strong> Cape Verdean Creole</p>
                    <p style={{marginBottom: '0.5rem'}}><strong>Other language(s):</strong></p>
                    
                    <table className={Style.skillsTable}>
                        <tbody>
                            <tr>
                                <td>English</td>
                                <td>
                                    Listening <strong>B2</strong> | Reading <strong>B2</strong> | Spoken interaction <strong>B1</strong><br/>
                                    Spoken production <strong>B1</strong> | Writing <strong>B2</strong>
                                </td>
                            </tr>
                            <tr>
                                <td>Portuguese</td>
                                <td>
                                    Listening <strong>C2</strong> | Reading <strong>C2</strong> | Spoken interaction <strong>C1</strong><br/>
                                    Spoken production <strong>C1</strong> | Writing <strong>C2</strong>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <p style={{fontSize: '0.85rem', color: '#666', fontStyle: 'italic', marginTop: '-1.5rem'}}>
                        Levels: A1 and A2: Basic user; B1 and B2: Independent user; C1 and C2: Proficient user
                    </p>
                </Box>

                <h2 className={Style.sectionTitle}>Digital Skills</h2>
                <Box className={Style.textSection}>
                    <ul style={{paddingLeft: '1.2rem', marginBottom: 0}}>
                        <li style={{marginBottom: '0.5rem'}}><strong>Development & Mobile:</strong> React, Flutter, JavaScript/TypeScript.</li>
                        <li style={{marginBottom: '0.5rem'}}><strong>Systems & DevOps:</strong> Linux (Ubuntu Server) and Windows Server Administration, Application Deployment, CI/CD, Cloud.</li>
                        <li style={{marginBottom: '0.5rem'}}><strong>AI & Automation:</strong> OpenAI API, Claude API, GitHub Copilot, Prompt Engineering.</li>
                        <li style={{marginBottom: '0.5rem'}}><strong>UX/UI & Design:</strong> Prototyping tools (Figma), user-oriented interface design.</li>
                        <li style={{marginBottom: '0.5rem'}}><strong>Multimedia:</strong> Advanced sound, video, and image editing.</li>
                        <li style={{marginBottom: '0'}}><strong>Soft Skills:</strong> Troubleshooting, Team Leadership, Cultural Adaptation, and Agile Methodologies.</li>
                    </ul>
                </Box>

            </Box>
        </>
    );
}

function CurriculumPT() {
    return (
        <>
            {/* LEFT SIDEBAR */}
            <Box className={Style.sidebar}>
                <Box className={Style.photoContainer}>
                    <img src={info.selfPortrait} alt="Profile" />
                </Box>
                
                <h1 className={Style.name}>Helber Ferreira<br/>Spencer</h1>
                <h2 style={{textAlign: 'center', fontSize: '1.15rem', color: '#666', marginTop: '-1.5rem', marginBottom: '2.5rem', fontWeight: 500}}>Software Developer & DevOps Engineer</h2>
                
                <Box className={Style.sidebarSection}>
                    <p><strong>Nacionalidade:</strong> Cabo-verdiana</p>
                    <p><strong>Residência:</strong> Portugal</p>
                </Box>

                <Box className={Style.sidebarSection}>
                    <h3>Contacto</h3>
                    <p><i className="fa-solid fa-location-dot"></i> Lisboa, Portugal</p>
                    <p><i className="fa-solid fa-envelope"></i> <a href="mailto:helber@dudedev.com">helber@dudedev.com</a></p>
                    <p><i className="fa-solid fa-phone"></i> (+351) 923174990</p>
                    <p><i className="fa-brands fa-linkedin"></i> <a href="https://linkedin.com/in/SEU-LINKEDIN-AQUI" target="_blank" rel="noreferrer">linkedin.com/in/helber</a></p>
                    <p><i className="fa-brands fa-github"></i> <a href="https://github.com/SEU-GITHUB-AQUI" target="_blank" rel="noreferrer">github.com/helber</a></p>
                </Box>
            </Box>

            {/* MAIN CONTENT */}
            <Box className={Style.mainContent}>
                <h2 className={Style.sectionTitle}>Sobre Mim</h2>
                <Box className={Style.textSection}>
                    Profissional de tecnologia com sólida experiência no desenvolvimento de aplicações web/mobile e gestão de infraestruturas (Linux/DevOps). Tenho um perfil analítico, grande capacidade de adaptação e facilidade na aprendizagem ágil de novas stacks tecnológicas. Com experiência prática que vai desde a idealização e arquitetura de startups até ao deploy e administração de servidores, procuro entregar soluções digitais robustas, seguras e com excelente usabilidade. Valorizo o trabalho em equipa, a comunicação clara e a otimização contínua dos processos de engenharia de software.
                </Box>

                <h2 className={Style.sectionTitle}>Experiência Profissional</h2>
                <Box className={Style.timeline}>
                    <Box className={Style.timelineItem}>
                        <div className={Style.date}>19/10/2020 – 07/04/2021 Seychelles</div>
                        <div className={Style.title}>Programador e CEO <span style={{fontWeight: 400}}>Linkup (Startup)</span></div>
                        <div className={Style.description}>
                            <ul>
                                <li>Desenvolvimento integral de um aplicativo de serviços de táxis (ride-hailing).</li>
                                <li>Gestão estratégica e liderança executiva (CEO) da startup operando em Seychelles.</li>
                                <li>Desenvolvimento de arquitetura mobile e backend para suporte em tempo real.</li>
                            </ul>
                        </div>
                    </Box>

                    <Box className={Style.timelineItem}>
                        <div className={Style.date}>04/06/2021 – 2022 Vitória, Brasil</div>
                        <div className={Style.title}>DevOps e Programador <span style={{fontWeight: 400}}>Ulen Brasil</span></div>
                        <div className={Style.description}>
                            <ul>
                                <li>Desenvolvimento de funcionalidades essenciais para a plataforma super app da Ulen.</li>
                                <li>Gestão de infraestrutura em nuvem (DevOps) focada em alta disponibilidade e escalabilidade.</li>
                                <li>Otimização de rotinas de deploy (CI/CD) e manutenção de servidores.</li>
                            </ul>
                        </div>
                    </Box>

                    <Box className={Style.timelineItem}>
                        <div className={Style.date}>20/01/2022 – 04/12/2023 Praia, Cabo Verde</div>
                        <div className={Style.title}>Fundador e Gestor de Sistemas <span style={{fontWeight: 400}}>CV INOVATE</span></div>
                        <div className={Style.description}>
                            <ul>
                                <li>Fundação e gestão integral de uma empresa de serviços tecnológicos.</li>
                                <li>Administração de Servidores e manutenção de infraestruturas de TI.</li>
                                <li>Implementação e otimização de sistemas computacionais para clientes.</li>
                            </ul>
                        </div>
                    </Box>

                    <Box className={Style.timelineItem}>
                        <div className={Style.date}>11/01/2022 – 04/06/2023 Praia, Cabo Verde</div>
                        <div className={Style.title}>Estagiário em Liderança Pedagógica <span style={{fontWeight: 400}}>Escola Secundária Cesaltina Ramos</span></div>
                        <div className={Style.description}>
                            <ul>
                                <li>Planeamento e execução de estratégias, desenvolvendo capacidades de liderança e comunicação em público.</li>
                            </ul>
                        </div>
                    </Box>
                </Box>

                <h2 className={Style.sectionTitle}>Educação e Formação</h2>
                <Box className={Style.timeline}>
                    <Box className={Style.timelineItem}>
                        <div className={Style.date}>26/04/2024 – ATUAL Praia, Cabo Verde</div>
                        <div className={Style.title}>Programador IOS e Gerenciador de Servidores Linux <span style={{fontWeight: 400}}>UDEMY</span></div>
                        <div className={Style.description}>
                            <strong>Sítio Web</strong> <a href="https://www.udemy.com" target="_blank" rel="noreferrer" style={{color: '#004494'}}>https://www.udemy.com</a> | <strong>Nível no QEQ</strong> Nível 1 QRQ
                        </div>
                    </Box>

                    <Box className={Style.timelineItem}>
                        <div className={Style.date}>03/10/2016 – 08/05/2022 Praia, Cabo Verde</div>
                        <div className={Style.title}>Licenciatura em Educação Fisica e Desporto <span style={{fontWeight: 400}}>Universidade de Cabo Verde</span></div>
                        <div className={Style.description}>
                            <strong>Sítio Web</strong> <a href="https://www.unicv.edu.cv/pt/" target="_blank" rel="noreferrer" style={{color: '#004494'}}>https://www.unicv.edu.cv/pt/</a> | <strong>Nível no QEQ</strong> Nível 3 QRQ
                        </div>
                    </Box>
                </Box>

                <h2 className={Style.sectionTitle}>Carta de Condução</h2>
                <Box className={Style.timeline} style={{marginBottom: '1.5rem', paddingBottom: 0}}>
                    <Box className={Style.timelineItem} style={{marginBottom: 0}}>
                        <div className={Style.title}>Carta de condução: <span style={{fontWeight: 400}}>B</span></div>
                    </Box>
                </Box>

                <h2 className={Style.sectionTitle}>Competências Linguísticas</h2>
                <Box className={Style.textSection}>
                    <p style={{marginBottom: '1rem'}}><strong>LÍNGUA(S) MATERNA(S):</strong> Kriolo de Cabo Verde</p>
                    <p style={{marginBottom: '0.5rem'}}><strong>Outra(s) língua(s):</strong></p>
                    
                    <table className={Style.skillsTable}>
                        <tbody>
                            <tr>
                                <td>inglês</td>
                                <td>
                                    Compreensão oral <strong>B2</strong> | Produção oral <strong>B1</strong> | Leitura <strong>B2</strong><br/>
                                    Interação oral <strong>B1</strong> | Escrita <strong>B2</strong>
                                </td>
                            </tr>
                            <tr>
                                <td>português</td>
                                <td>
                                    Compreensão oral <strong>C2</strong> | Produção oral <strong>C1</strong> | Leitura <strong>C2</strong><br/>
                                    Interação oral <strong>C1</strong> | Escrita <strong>C2</strong>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <p style={{fontSize: '0.85rem', color: '#666', fontStyle: 'italic', marginTop: '-1.5rem'}}>
                        Níveis: A1 e A2: Utilizador de base; B1 e B2: Utilizador independente; C1 e C2: Utilizador avançado
                    </p>
                </Box>

                <h2 className={Style.sectionTitle}>Competências Digitais</h2>
                <Box className={Style.textSection}>
                    <ul style={{paddingLeft: '1.2rem', marginBottom: 0}}>
                        <li style={{marginBottom: '0.5rem'}}><strong>Desenvolvimento & Mobile:</strong> React, Flutter, JavaScript/TypeScript.</li>
                        <li style={{marginBottom: '0.5rem'}}><strong>Sistemas & DevOps:</strong> Administração de Servidores Linux (Ubuntu Server) e Windows Server, Deploy de aplicações, CI/CD, Cloud.</li>
                        <li style={{marginBottom: '0.5rem'}}><strong>Inteligência Artificial:</strong> Integração com APIs (OpenAI/Claude), GitHub Copilot, Prompt Engineering.</li>
                        <li style={{marginBottom: '0.5rem'}}><strong>UX/UI & Design:</strong> Ferramentas de prototipagem (Figma), design de interfaces orientadas ao utilizador.</li>
                        <li style={{marginBottom: '0.5rem'}}><strong>Multimédia:</strong> Edição avançada de som, vídeo e imagem.</li>
                        <li style={{marginBottom: '0'}}><strong>Soft Skills:</strong> Troubleshooting (resolução de problemas), Liderança de equipas, Adaptação cultural e Metodologias Ágeis.</li>
                    </ul>
                </Box>

            </Box>
        </>
    );
}

export default function Curriculum({ innerRef }) {
    const { language } = useContext(LanguageContext);

    return (
        <Box ref={innerRef} className={Style.container} id={'curriculum'}>
            {language === 'pt' ? <CurriculumPT /> : <CurriculumEN />}
        </Box>
    );
}
